import React, { PropTypes, Component } from 'react'
import classNames from 'classnames'
import styles from './styles'

export default class ItemBox extends Component {
  static propTypes = {
    item: PropTypes.string,
    selected: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
  };

  constructor (props) {
    super(props)
  }

  render () {
    const { onClick, item, selected } = this.props
    return (
      <div
        className={classNames(styles.itemBox, { [styles.selected]: selected })}
        onClick={onClick}
      >
        <span>{item}</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/autocomplete/itemBox.jsx